import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';
import type RoleView from '@UI/Store/Roles/Views/RoleView';

type RoleFormArgs = {
	label: string;
	description: string;
};

/**
 * Only carries `label` and `description`: a role is created empty and composed afterwards on the
 * card, and the server derives `name` from `label` — there is nothing here for it, and sending one
 * would be rejected by `forbidNonWhitelisted`.
 */
@ValidatedClass()
class RoleFormData extends AbstractValidatedClass<RoleFormArgs> {
	@constraint(Joi.string().max(255), () => 'Le libellé ne doit pas dépasser 255 caractères.')
	@constraint(Joi.string().required(), () => 'Le libellé est obligatoire.')
	public readonly label: string;

	@constraint(
		Joi.string().max(1000).allow(''),
		() => 'La description ne peut pas dépasser 1000 caractères.',
	)
	public readonly description: string;

	constructor(data: RoleFormArgs) {
		super(data);
		this.label = data.label;
		this.description = data.description;
		Object.freeze(this);
	}

	static createEmpty(): RoleFormData {
		return new RoleFormData({ label: '', description: '' });
	}

	static fromView(role: RoleView): RoleFormData {
		return new RoleFormData({ label: role.label, description: role.description ?? '' });
	}

	setLabel(label: string): this {
		return this.cloneWith({ label } as Partial<RoleFormArgs>);
	}

	setDescription(description: string): this {
		return this.cloneWith({ description } as Partial<RoleFormArgs>);
	}
}

export default RoleFormData;
